<script>
export default {};
</script>

<template>
  <section>
    <slot></slot>
  </section>
</template>

<style lang="scss" scoped>
section {
  background: var(--gradient);
  box-shadow: 3px 5px 8px -3px rgba(0, 0, 0, 0.5);
  padding: 10px 30px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  transition: all 0.5s ease;

  &:hover {
    transform: translateY(-8px);
  }

  @media (min-width: 342px) {
    padding: 20px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_base/Title.vue